import * as styles from './Submit.css';
import Button from '@/components/Button/Button';
import { memo } from 'react';
import useLoading from '@/hooks/react/useLoading';
import useApplyEventId from '../../hooks/useApplyEventId';
import useEventSubmit from '../../hooks/useEventSubmit';

type PropTypes = {
  agreed: boolean;
  availableSubmit: boolean;
};

const Submit = memo(({ agreed, availableSubmit }: PropTypes) => {
  const [loading, start] = useLoading();

  const eventId = useApplyEventId();

  const submit = useEventSubmit();

  const handleClick = () => {
    if (loading) return;
    start(submit(eventId));
  };

  return (
    <div className={styles.container}>
      <Button
        type="solid"
        category="primary"
        size="xxlarge"
        onClick={handleClick}
        loading={loading}
        disabled={!agreed}
      >
        {availableSubmit ? '응모하기' : '이미 응모한 이벤트예요'}
      </Button>
    </div>
  );
});

export default Submit;
